import { findBoundsOfArrayOfItems } from "./findBoundsOfArrayOfItems";

export async function PositionItemsInOrder(updateArray) {
  const allBounds = findBoundsOfArrayOfItems(updateArray);
  let firstItem = updateArray[0];
  let previousItem = undefined;
  for (const item of updateArray) {
    if (previousItem) {
      item.x =
        previousItem.x +
        previousItem.width / 2 +
        firstItem.width * 0.1 +
        item.width / 2;
    } else {
      item.x = allBounds.left + item.width / 2;
    }
    item.y = allBounds.centroidY;
    await item.sync();
    previousItem = item;
  }
}
